<div class="content-wrap list-products-page">
    <div class="container">
        <div class="breadcrumb">
            <app-bread-crumb [data]="breadCrumb"></app-bread-crumb>
        </div>
        <div class="title-catalogue d-flex justify-content-between align-items-center">
            <h2 *ngIf="pathCurrentText === 'new-product'" class="title-nouveau-product">
                {{ 'IRONSIDE.product-list.new-product' | translate | uppercase }}
            </h2>
            <h2 *ngIf="favListName?.length ?? 0 > 0" class="title-nouveau-product">
                <div>
                    <span class="sub-title"
                        >{{ 'IRONSIDE.my-favourites.MY_FAVOURITE' | translate }} :
                    </span>
                    {{ favListName | uppercase }}
                </div>
            </h2>
            <div class=" ">
                <p class="search-result" *ngIf="formFilter.value.research">
                    {{ 'IRONSIDE.product-list.search-result-for' | translate }} :
                    <span>{{ formFilter.value.research }}</span>
                </p>
                <p
                    class="search-result cateName"
                    style="margin-bottom: 0"
                    *ngIf="categoryName && !researchValue"
                >
                    {{ categoryName | translateDynamicLanguage }}
                </p>

                <p class="search-result cateName" style="margin-bottom: 0" *ngIf="idMarque">
                    {{ getNameBrand }}
                </p>

                <div
                    *ngIf="headerType === 'supplier'"
                    class="d-flex align-items-center justify-content-start flex-row"
                    style="gap: 10px"
                >
                    <div>
                        <img
                            [src]="
                                getSupplierByCode()?.logo ??
                                'src-ironside/assets/images/image-default.jpg'
                            "
                            height="90"
                            width="110"
                            style="object-fit: contain"
                        />
                    </div>
                    <div class="cf">
                        <p style="line-height: 1.8; margin: 0">
                            <span class="sub-title"
                                >{{ 'IRONSIDE.product-list.supplier-catalog' | translate }} :
                            </span>
                            <span class="title">{{ getSupplierByCode()?.title }}</span>
                        </p>
                    </div>
                </div>
            </div>

            <ng-container *ngIf="isExeportVisible && isPermissionAllExport">
                <div fxLayout="row" fxLayoutAlign="center center" style="gap: 10px">
                    <div
                        class="btn-deselect-all"
                        *ngIf="totalSelected > 0"
                        (click)="onCancelSelectedProduct()"
                    >
                        {{
                            'IRONSIDE.product-list.deselect-all'
                                | translate : { quantity: totalSelected }
                        }}
                    </div>
                    <div class="export">
                        <button
                            class="btn-common btn-exporter"
                            (click)="onShowTypeExport()"
                            [disabled]="!products?.length"
                        >
                            <span>{{ 'IRONSIDE.product-list.export' | translate | uppercase }}</span
                            ><mat-spinner
                                *ngIf="
                                    loadingExport && sessionStorageService.getFilters()?.isfavLis
                                "
                                [diameter]="15"
                            ></mat-spinner>
                        </button>
                        <div class="content-exporter-fav" *ngIf="exportVisible">
                            <div *ngFor="let item of exportOption">
                                <div
                                    *ngIf="item?.permission"
                                    class="exporter-item d-flex align-items-center gap-2"
                                >
                                    <p-checkbox
                                        [(ngModel)]="itemExportSelected"
                                        [value]="item.key"
                                        [label]="'export.' + item.label | translate"
                                        [inputId]="item.key"
                                        [disabled]="isDisabled(item.key) || item.quantity === 0"
                                    ></p-checkbox>
                                </div>
                            </div>
                            <div>
                                <div class="action-show-exporter">
                                    <button class="btn-export-common" (click)="onCancelExport()">
                                        <span>{{
                                            'IRONSIDE.tabview-product.CANCEL'
                                                | translate
                                                | lowercase
                                                | titlecase
                                        }}</span>
                                    </button>

                                    <button
                                        class="btn-export-common truncate"
                                        [disabled]="
                                            !itemExportSelected.length ||
                                            loadingExport ||
                                            isProgress
                                        "
                                        (click)="onExportResource()"
                                        [ngStyle]="{
                                            backgroundColor:
                                                !itemExportSelected.length ||
                                                loadingExport ||
                                                isProgress
                                                    ? '#0000008c'
                                                    : ''
                                        }"
                                        style="
                                            display: flex;
                                            align-items: center;
                                            gap: 4px;
                                            justify-content: center;
                                        "
                                    >
                                        <span>{{
                                            'IRONSIDE.product-list.export'
                                                | translate
                                                | lowercase
                                                | titlecase
                                        }}</span>
                                    </button>
                                </div>

                                <div
                                    *ngIf="loadingExport || isProgress"
                                    class="progress-bar-exporter loading-dots"
                                >
                                    {{ 'export.EXPORTING_FILE' | translate }}<span>.</span
                                    ><span>.</span><span>.</span>
                                    <p-progressBar [value]="progressNumber"></p-progressBar>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-container>
        </div>
        <div class="list-products-page-inner">
            <div class="main-content-list-products d-flex mb-5">
                <div class="col-3 p-0 pr-3 wrap-filter">
                    <p class="font-bold text-filter">
                        {{ 'IRONSIDE.product-list.filters-added' | translate }}
                    </p>

                    <ng-container *ngTemplateOutlet="tagTemplate"></ng-container>
                    <ng-container *ngIf="visibleDialog; else actionTemplate"></ng-container>
                    <div class="form-filter-left">
                        <ng-container *ngTemplateOutlet="formFilterTemplate"></ng-container>
                    </div>
                </div>
                <div class="col-9 p-0">
                    <form [formGroup]="formPagination" class="">
                        <div class="wrap-pagination">
                            <div class="d-flex justify-content-between align-items-center mb-3">
                                <div class="wrap-rows">
                                    {{ 'IRONSIDE.product-list.show' | translate }}
                                    <p-dropdown
                                        formControlName="rows"
                                        (onChange)="filterRows($event)"
                                        class="item-page"
                                        [options]="listRows"
                                        optionLabel=""
                                        [(ngModel)]="pageSize"
                                    ></p-dropdown
                                    >{{ 'IRONSIDE.product-list.elements' | translate }}
                                </div>
                                <p-paginator
                                    *ngIf="
                                        products && products.length > 0 && totalRecords > pageSize
                                    "
                                    (onPageChange)="onPageChange($event)"
                                    [first]="first"
                                    [rows]="pageSize"
                                    [totalRecords]="totalRecords"
                                    [showFirstLastIcon]="false"
                                    [showCurrentPageReport]="false"
                                ></p-paginator>
                            </div>
                        </div>
                    </form>
                    <div class="product-content">
                        <div
                            *ngFor="let product of products; let i = index"
                            class="product-item"
                            #lazyItem
                            [attr.data-lazyId]="product.id"
                        >
                            <div>
                                <div class="d-flex title-inner">
                                    <div class="image-product">
                                        <img
                                            [src]="getResourceValidData(product?.resourceParent)"
                                            alt=""
                                        />
                                    </div>
                                    <div class="product-infor">
                                        <h3>
                                            <a
                                                [routerLink]="
                                                    '/product/detail/' + product.referenceProduct
                                                "
                                                target="_blank"
                                                href=""
                                                >{{ product.title | translateDynamicLanguage }}</a
                                            >
                                        </h3>
                                        <p>
                                            {{ 'IRONSIDE.product-list.brand' | translate }} :
                                            {{ product.brand | translateDynamicLanguage }}
                                        </p>
                                        <p>
                                            {{ 'IRONSIDE.product-list.department' | translate }}
                                            :
                                            <ng-container
                                                *ngFor="
                                                    let item of product.department;
                                                    let last = last
                                                "
                                            >
                                                <span>{{
                                                    item.labels | translateDynamicLanguage
                                                }}</span>
                                                <span *ngIf="!last"> , </span>
                                            </ng-container>
                                        </p>
                                        <p *ngIf="product?.standard">
                                            {{ 'IRONSIDE.product-list.standard' | translate }} :
                                            {{ product.standard }}
                                        </p>
                                        <div *ngIf="product.state" class="under-evaluation">
                                            <span>{{ product.state }}</span>
                                        </div>
                                        <div class="wrap-btn d-flex align-items-center">
                                            <button
                                                *ngIf="
                                                    permissionService.isPermissionFonction(
                                                        'comparateur-produit'
                                                    )
                                                "
                                                class="btn-common comparer-btn d-flex align-items-center me-3"
                                                (click)="addProductToCompare(product?.id)"
                                                (mouseenter)="onToggleIcon($event, 'yellow')"
                                                (mouseleave)="onToggleIcon($event, 'white')"
                                            >
                                                <img
                                                    id="comparator-icon"
                                                    class="me-2"
                                                    src="/src-ironside/assets/icons/comparator_white.svg"
                                                    alt=""
                                                />{{ 'IRONSIDE.product-list.compare' | translate }}
                                            </button>
                                            <button
                                                [ngClass]="
                                                    product.isFavorite
                                                        ? 'btn-favorite-selected'
                                                        : 'btn-favorite-unselected'
                                                "
                                                *ngIf="
                                                    permissionService.isPermissionFonction(
                                                        'favoris'
                                                    )
                                                "
                                                mat-icon-button
                                            >
                                                <ng-container
                                                    *ngIf="product.isFavorite; else elseTemplate"
                                                >
                                                    <img
                                                        (click)="removeFromFavorites(product)"
                                                        src="src-ironside/assets/icons/bookmark_yellow.svg"
                                                        alt="icon-favorite-selected"
                                                        width="27"
                                                        height="27"
                                                    />
                                                </ng-container>
                                                <ng-template #elseTemplate>
                                                    <div
                                                        class="d-flex align-items-center gap-1"
                                                        (click)="checkHasFavorites(i)"
                                                        [matMenuTriggerFor]="menu"
                                                    >
                                                        <mat-icon
                                                            style="
                                                                font-size: 16px;
                                                                width: 14px;
                                                                color: #000;
                                                            "
                                                            >add</mat-icon
                                                        >
                                                        <span>{{
                                                            'IRONSIDE.product-list.my-lists'
                                                                | translate
                                                        }}</span>
                                                        <img
                                                            src="src-ironside/assets/icons/bookmark_black.svg"
                                                            alt="icon-favorite-unselected"
                                                            width="27"
                                                            height="27"
                                                        />
                                                    </div>
                                                </ng-template>
                                            </button>
                                            <mat-menu #menu>
                                                <div class="wrap-favorites">
                                                    <ng-container *ngFor="let item of favorites">
                                                        <button
                                                            (click)="
                                                                addToFavorites(item.id, product)
                                                            "
                                                            mat-menu-item
                                                        >
                                                            {{ item.name }}
                                                        </button>
                                                    </ng-container>
                                                </div>
                                                <div class="container-btn-create-favourit">
                                                    <button
                                                        (click)="onOpenDialog(product)"
                                                        mat-menu-item
                                                        class="btn-create-favourit"
                                                    >
                                                        <mat-icon>add</mat-icon>
                                                        {{
                                                            'IRONSIDE.product-list.create-new-list'
                                                                | translate
                                                        }}
                                                    </button>
                                                </div>
                                            </mat-menu>
                                        </div>
                                    </div>
                                </div>

                                <div class="table-product">
                                    <table>
                                        <thead style="position: sticky; top: 0">
                                            <tr>
                                                <th *ngIf="isPermissionAllExport">
                                                    <mat-checkbox
                                                        [checked]="
                                                            isAllSelected(
                                                                product?.id ?? '',
                                                                product.fullExtendData ?? []
                                                            )
                                                        "
                                                        [indeterminate]="
                                                            isIndeterminate(
                                                                product?.id ?? '',
                                                                product.fullExtendData ?? []
                                                            )
                                                        "
                                                        (change)="
                                                            toggleSelectAll(
                                                                $event.checked,
                                                                product?.id ?? '',
                                                                product.fullExtendData ?? []
                                                            )
                                                        "
                                                        (click)="$event.stopPropagation()"
                                                    >
                                                    </mat-checkbox>
                                                </th>
                                                <th></th>
                                                <th>
                                                    {{
                                                        'IRONSIDE.product-list.ref-ean' | translate
                                                    }}
                                                </th>
                                                <th>
                                                    {{
                                                        'IRONSIDE.product-list.description'
                                                            | translate
                                                    }}
                                                </th>
                                                <th>
                                                    {{
                                                        'IRONSIDE.product-list.specifications'
                                                            | translate
                                                    }}
                                                </th>

                                                <th
                                                    *ngIf="
                                                        permissionService.isPermissionFonction(
                                                            'visibilite-tarifs'
                                                        )
                                                    "
                                                >
                                                    {{ 'IRONSIDE.product-list.prices' | translate }}
                                                </th>
                                                <th>
                                                    {{
                                                        'IRONSIDE.product-list.pack-unit'
                                                            | translate
                                                    }}
                                                </th>
                                                <th>
                                                    {{
                                                        'IRONSIDE.product-list.associated-partners'
                                                            | translate
                                                    }}
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody *ngIf="product.fullExtendData">
                                            <tr
                                                *ngFor="
                                                    let fullExtendDataItem of product.fullExtendData
                                                "
                                            >
                                                <td *ngIf="isPermissionAllExport">
                                                    <mat-checkbox
                                                        [checked]="
                                                            isChildSelected(
                                                                product.id ?? '',
                                                                fullExtendDataItem.id
                                                            )
                                                        "
                                                        (change)="
                                                            toggleChildSelection(
                                                                $event.checked,
                                                                product.id ?? '',
                                                                fullExtendDataItem
                                                            )
                                                        "
                                                    ></mat-checkbox>
                                                </td>
                                                <td>
                                                    <ng-container
                                                        *ngIf="
                                                            isCurrentDateInRange(
                                                                fullExtendDataItem
                                                            ) || fullExtendDataItem?.state
                                                        "
                                                    >
                                                        <div class="section-tag">
                                                            <span
                                                                *ngIf="
                                                                    isCurrentDateInRange(
                                                                        fullExtendDataItem
                                                                    )
                                                                "
                                                                class="new-tag"
                                                                >{{
                                                                    'IRONSIDE.product-list.new'
                                                                        | translate
                                                                }}</span
                                                            >
                                                            <span
                                                                *ngIf="fullExtendDataItem?.state"
                                                                class="state-tag"
                                                                >{{
                                                                    fullExtendDataItem?.state
                                                                        ?.labels
                                                                        | translateDynamicLanguageTable
                                                                        | uppercase
                                                                }}</span
                                                            >
                                                        </div>
                                                    </ng-container>
                                                </td>
                                                <td>
                                                    <strong
                                                        class="ref-clickable"
                                                        (click)="
                                                            onRedirectToProductDetail(
                                                                product?.referenceProduct ?? ''
                                                            )
                                                        "
                                                    >
                                                        {{ fullExtendDataItem.refEan }}
                                                    </strong>
                                                    <br />
                                                    <strong>{{
                                                        fullExtendDataItem.gencodeProduct
                                                    }}</strong>

                                                    <br />
                                                    <span
                                                        style="font-weight: 400"
                                                        *ngIf="
                                                            fullExtendDataItem.manufacturerReference
                                                        "
                                                        >{{
                                                            fullExtendDataItem.manufacturerReference
                                                        }}</span
                                                    >
                                                </td>
                                                <td>
                                                    <span
                                                        style="font-weight: 400"
                                                        class="ref-clickable"
                                                        (click)="
                                                            onRedirectToProductDetail(
                                                                product?.referenceProduct ?? ''
                                                            )
                                                        "
                                                    >
                                                        {{
                                                            fullExtendDataItem.des
                                                                | translateDynamicLanguageTable
                                                        }}
                                                    </span>
                                                </td>
                                                <td>
                                                    {{
                                                        fullExtendDataItem.spec
                                                            | translateDynamicLanguageTable
                                                    }}
                                                </td>
                                                <td
                                                    *ngIf="
                                                        permissionService.isPermissionFonction(
                                                            'visibilite-tarifs'
                                                        )
                                                    "
                                                >
                                                    <div
                                                        style="padding: 6px 0"
                                                        *ngFor="
                                                            let prix of convertTariffs(
                                                                fullExtendDataItem?.prixs
                                                            );
                                                            let last = last
                                                        "
                                                        [ngClass]="{
                                                            'price-item':
                                                                !last &&
                                                                (fullExtendDataItem?.prixs
                                                                    ?.length ??
                                                                    0) >
                                                                    1
                                                        }"
                                                    >
                                                        <span
                                                            class="truncate"
                                                            style="
                                                                display: inline;
                                                                margin-right: 6px;
                                                                font-size: 14px;
                                                            "
                                                            *ngIf="prix[0]"
                                                            >{{ prix[0] }}</span
                                                        >
                                                        <span
                                                            class="truncate"
                                                            style="font-weight: 400"
                                                            *ngIf="prix[1]"
                                                            >{{ prix[1] }}</span
                                                        >
                                                        <div class="truncate" *ngIf="prix[2]">
                                                            {{ prix[2] }}
                                                        </div>
                                                        <div
                                                            class="truncate"
                                                            style="display: inline"
                                                            *ngIf="prix[3]"
                                                        >
                                                            <a
                                                                class="link-supplier"
                                                                (click)="
                                                                    onRedirectToSupplier(
                                                                        prix[3]?.documentId
                                                                    )
                                                                "
                                                                >{{ prix[3]?.value }}</a
                                                            >
                                                        </div>
                                                    </div>
                                                </td>
                                                <!-- <td class="truncate">
                                                {{
                                                    fullExtendDataItem?.lengthProduct || 0
                                                        | translateDynamicLanguage
                                                }}
                                                x
                                                {{
                                                    fullExtendDataItem?.widthProduct || 0
                                                        | translateDynamicLanguage
                                                }}
                                                x
                                                {{
                                                    fullExtendDataItem?.heightProduct || 0
                                                        | translateDynamicLanguage
                                                }}
                                            </td> -->
                                                <td style="text-align: center">
                                                    <span
                                                        style="font-weight: 400; width: fit-content"
                                                        *ngIf="
                                                            fullExtendDataItem?.packSmallest
                                                                ?.conditioning
                                                        "
                                                        >{{
                                                            fullExtendDataItem?.packSmallest
                                                                ?.conditioning
                                                        }}</span
                                                    >
                                                </td>
                                                <td>
                                                    <div
                                                        *ngFor="
                                                            let partner of fullExtendDataItem.partners
                                                        "
                                                    >
                                                        {{ partner?.value }}
                                                    </div>
                                                </td>
                                            </tr>
                                        </tbody>

                                        <!-- skeleton start -->
                                        <tbody *ngIf="!product.fullExtendData">
                                            <tr *ngFor="let _ of product.linkedProducts">
                                                <td
                                                    *ngIf="
                                                        permissionService.isPermissionFonction(
                                                            'visibilite-tarifs'
                                                        )
                                                    "
                                                >
                                                    <p-skeleton></p-skeleton>
                                                </td>
                                                <td><p-skeleton></p-skeleton></td>
                                                <td><p-skeleton></p-skeleton></td>
                                                <td><p-skeleton></p-skeleton></td>
                                                <td><p-skeleton></p-skeleton></td>
                                                <td><p-skeleton></p-skeleton></td>
                                                <td><p-skeleton></p-skeleton></td>
                                                <td><p-skeleton></p-skeleton></td>
                                            </tr>
                                        </tbody>
                                        <!-- skeleton end -->
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                    <form [formGroup]="formPagination" class="">
                        <div *ngIf="products && products.length > 0" class="wrap-pagination">
                            <div class="d-flex justify-content-between align-items-center mb-3">
                                <div class="wrap-rows">
                                    {{ 'IRONSIDE.product-list.show' | translate }}
                                    <p-dropdown
                                        formControlName="rows"
                                        (onChange)="filterRows($event)"
                                        class="item-page"
                                        [options]="listRows"
                                        optionLabel=""
                                        [(ngModel)]="pageSize"
                                    ></p-dropdown
                                    >{{ 'IRONSIDE.product-list.elements' | translate }}
                                </div>
                                <p-paginator
                                    *ngIf="
                                        products && products.length > 0 && totalRecords > pageSize
                                    "
                                    (onPageChange)="onPageChange($event)"
                                    [first]="first"
                                    [rows]="pageSize"
                                    [totalRecords]="totalRecords"
                                    [showFirstLastIcon]="false"
                                    [showCurrentPageReport]="false"
                                ></p-paginator>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</div>
<p-dialog
    class="filter-dialog"
    [modal]="true"
    [(visible)]="visibleDialog"
    [style]="{ width: '80%' }"
    [draggable]="false"
    [resizable]="false"
    [closable]="true"
    [header]="'Catalogue.modify' | translate"
>
    <div class="list-products-page-inner">
        <div class="main-content-list-products d-flex">
            <div class="wrap-filter" style="width: 100%">
                <ng-container *ngTemplateOutlet="tagTemplate"></ng-container>
                <div class="list-products-page">
                    <ng-template *ngTemplateOutlet="formFilterTemplate"></ng-template>
                </div>
                <div class="d-flex justify-content-end mt-3">
                    <button class="btn-common btn-reset-filter" (click)="visibleDialog = false">
                        {{ 'IRONSIDE.tabview-product.VALIDATE' | translate }}
                    </button>
                </div>
            </div>
        </div>
    </div>
</p-dialog>
<ng-template #formFilterTemplate>
    <p-panel [toggleable]="true" [(collapsed)]="isCategoryPanelCollapsed">
        <ng-template pTemplate="header">
            <div
                (click)="isCategoryPanelCollapsed = !isCategoryPanelCollapsed"
                style="cursor: pointer"
            >
                {{ 'IRONSIDE.product-list.categories' | translate }}
            </div>
        </ng-template>
        <div class="wrap-categories">
            <div class="d-flex align-items-center gap-2" *ngFor="let category of categories">
                <p-panel
                    class="lv-1"
                    [toggleable]="
                        category &&
                        !!category.subcategoryList &&
                        category.subcategoryList?.length > 0
                    "
                    [collapsed]="!isExpanded(category)"
                >
                    <ng-template pTemplate="header">
                        <!-- (click)="selectCategory(category)" -->
                        <div class="sub-category">
                            <p-checkbox
                                (ngModelChange)="onCategoryCheckboxChange($event, category)"
                                [value]="category?.id"
                                [binary]="true"
                                [inputId]="'category-' + category.id"
                                [(ngModel)]="categoriesCheckedMap[category?.id ?? '']"
                            ></p-checkbox>
                            <label class="m-0 label-category">{{
                                (category?.nameCategory | translateDynamicLanguage) || ''
                            }}</label>
                        </div>
                    </ng-template>
                    <div
                        class="d-flex align-items-center gap-2"
                        style="border-top: 1px solid #7070704d"
                        *ngFor="let lv2Category of category?.subcategoryList"
                    >
                        <p-panel
                            class="lv-2"
                            [toggleable]="
                                lv2Category &&
                                !!lv2Category.subcategoryList &&
                                lv2Category.subcategoryList.length > 0
                            "
                            [collapsed]="!isExpanded(lv2Category)"
                        >
                            <ng-template pTemplate="header">
                                <!-- (click)="selectCategory(lv2Category)" -->
                                <div class="sub-category" style="padding: 6px 0 6px 20px">
                                    <p-checkbox
                                        (ngModelChange)="
                                            onCategoryCheckboxChange($event, lv2Category, category)
                                        "
                                        [binary]="true"
                                        [inputId]="'category-' + lv2Category.id"
                                        [(ngModel)]="categoriesCheckedMap[lv2Category.id]"
                                        [value]="lv2Category?.id"
                                    ></p-checkbox>
                                    <label class="m-0 label-category">{{
                                        (lv2Category?.nameCategory | translateDynamicLanguage) || ''
                                    }}</label>
                                </div>
                            </ng-template>
                            <div
                                class="d-flex align-items-center gap-2"
                                *ngFor="let lv3Category of lv2Category?.subcategoryList"
                            >
                                <p-panel class="lv-2" [collapsed]="!isExpanded(lv3Category)">
                                    <ng-template pTemplate="header">
                                        <!-- (click)="selectCategory(lv3Category)" -->
                                        <div class="sub-category" style="padding-left: 30px">
                                            <p-checkbox
                                                [value]="lv3Category?.id"
                                                (ngModelChange)="
                                                    onCategoryCheckboxChange(
                                                        $event,
                                                        lv3Category,
                                                        lv2Category
                                                    )
                                                "
                                                [binary]="true"
                                                [(ngModel)]="categoriesCheckedMap[lv3Category.id]"
                                                [inputId]="'category-' + lv3Category.id"
                                            ></p-checkbox>
                                            <label class="m-0 label-category">{{
                                                (lv3Category?.nameCategory
                                                    | translateDynamicLanguage) || ''
                                            }}</label>
                                        </div>
                                    </ng-template>
                                </p-panel>
                            </div>
                        </p-panel>
                    </div>
                </p-panel>
            </div>
        </div>
    </p-panel>

    <form [formGroup]="formFilter">
        <p-panel
            *ngIf="
                permissionService.isPermissionFonction('visibilite-tarifs') ||
                (permissionService.isPermissionFonction('visibilite-tarifs') &&
                    headerType !== 'supplier')
            "
            [toggleable]="true"
            [(collapsed)]="isSupplierPanelCollapsed"
        >
            <ng-template pTemplate="header">
                <div
                    (click)="isSupplierPanelCollapsed = !isSupplierPanelCollapsed"
                    style="cursor: pointer"
                >
                    {{ 'IRONSIDE.product-list.supplier' | translate }}
                </div>
            </ng-template>
            <div
                class="wrap-input d-flex align-items-center justify-content-between gap-2 pb-2 mt-2"
            >
                <p-multiSelect
                    [filter]="true"
                    class="w-12"
                    [options]="suppliers"
                    optionLabel="title"
                    optionValue="id"
                    placeholder="{{ 'IRONSIDE.product-list.choose-suppliers' | translate }}"
                    formControlName="suppliers"
                    appendTo="body"
                ></p-multiSelect>
            </div>
        </p-panel>

        <p-panel
            *ngIf="headerType !== 'marque'"
            [toggleable]="true"
            [(collapsed)]="isBrandPanelCollapsed"
        >
            <ng-template pTemplate="header">
                <div
                    (click)="isBrandPanelCollapsed = !isBrandPanelCollapsed"
                    style="cursor: pointer"
                >
                    {{ 'IRONSIDE.product-list.brand' | translate }}
                </div>
            </ng-template>
            <div
                class="wrap-input d-flex align-items-center justify-content-between gap-2 pb-2 mt-2"
            >
                <p-multiSelect
                    [filter]="true"
                    class="w-12"
                    [options]="getFilterTranslateBrand(brands)"
                    optionLabel="translatedTitle"
                    optionValue="id"
                    placeholder="{{ 'IRONSIDE.product-list.choose-brands' | translate }}"
                    formControlName="brand"
                    appendTo="body"
                >
                    <ng-template let-brand pTemplate="item">
                        <div class="truncate">
                            {{ brand.title | translateDynamicLanguage }}
                        </div>
                    </ng-template>

                    <ng-template let-value pTemplate="selectedItems">
                        <div class="truncate">
                            <span
                                class="truncate"
                                style="margin-right: 4px"
                                *ngFor="let option of brandValueOption"
                            >
                                <span>{{ option?.title | translateDynamicLanguage }}</span>
                                <span *ngIf="brandValueOption.length > 1">,</span>
                            </span>
                        </div>

                        <span *ngIf="!brandValueOption || brandValueOption.length === 0">{{
                            'IRONSIDE.product-list.choose-brands' | translate
                        }}</span>
                    </ng-template>
                </p-multiSelect>
            </div>
        </p-panel>

        <p-panel [toggleable]="true" [(collapsed)]="isManufacturingCountryPanelCollapsed">
            <ng-template pTemplate="header">
                <div
                    (click)="
                        isManufacturingCountryPanelCollapsed = !isManufacturingCountryPanelCollapsed
                    "
                    style="cursor: pointer"
                >
                    {{ 'IRONSIDE.product-list.manufacturing-country' | translate }}
                </div>
            </ng-template>
            <div
                class="wrap-input d-flex align-items-center justify-content-between gap-2 pb-2 mt-2"
            >
                <p-multiSelect
                    [filter]="true"
                    class="w-12"
                    [options]="getFilterTranslate(countries)"
                    optionLabel="translatedTitle"
                    optionValue="id"
                    placeholder="{{ 'IRONSIDE.product-list.choose-countries' | translate }}"
                    formControlName="manufactoringCountry"
                    appendTo="body"
                >
                    <ng-template let-country pTemplate="item">
                        <div class="truncate">
                            {{ country.title | translateDynamicLanguage }}
                        </div>
                    </ng-template>

                    <ng-template let-value pTemplate="selectedItems">
                        <div class="truncate">
                            <span
                                class="truncate"
                                style="margin-right: 4px"
                                *ngFor="let option of manufactoringCountryValueOption"
                            >
                                <span>{{ option?.title | translateDynamicLanguage }}</span>
                                <span *ngIf="manufactoringCountryValueOption.length > 1">,</span>
                            </span>
                        </div>

                        <span
                            *ngIf="
                                !manufactoringCountryValueOption ||
                                manufactoringCountryValueOption.length === 0
                            "
                            >{{ 'IRONSIDE.product-list.choose-countries' | translate }}</span
                        >
                    </ng-template>
                </p-multiSelect>
            </div>
        </p-panel>

        <p-panel
            *ngIf="pathCurrentText !== 'new-product'"
            [toggleable]="true"
            [(collapsed)]="isNewProductPanelCollapsed"
        >
            <ng-template pTemplate="header">
                <div
                    (click)="isNewProductPanelCollapsed = !isNewProductPanelCollapsed"
                    style="cursor: pointer"
                >
                    {{ 'IRONSIDE.product-list.new-product' | translate | uppercase }}
                </div>
            </ng-template>
            <div
                class="wrap-input d-flex align-items-center justify-content-between gap-2 pb-2 pl-1"
            >
                <div class="flex align-items-center gap-3">
                    <p-checkbox
                        formControlName="isNewProduct"
                        [binary]="true"
                        inputId="cli1"
                    ></p-checkbox>
                    <label for="cli1" class="m-0">
                        {{ 'IRONSIDE.yes' | translate }}
                    </label>
                </div>
            </div>
        </p-panel>

        <p-panel [toggleable]="true" [(collapsed)]="isWithdrawnFromSalePanelCollapsed">
            <ng-template pTemplate="header">
                <div
                    (click)="isWithdrawnFromSalePanelCollapsed = !isWithdrawnFromSalePanelCollapsed"
                    style="cursor: pointer"
                >
                    {{ 'IRONSIDE.product-list.off-market-product' | translate }}
                </div>
            </ng-template>
            <div
                class="wrap-input d-flex align-items-center justify-content-between gap-2 pb-2 pl-1"
            >
                <div class="flex align-items-center gap-3">
                    <p-checkbox
                        formControlName="isOffMarketProduct"
                        [binary]="true"
                        inputId="clp1"
                    ></p-checkbox>
                    <label for="clp1" class="m-0">{{
                        'IRONSIDE.product-list.yes' | translate
                    }}</label>
                </div>
            </div>
        </p-panel>

        <p-panel [toggleable]="true" [(collapsed)]="isDepartmentPanelCollapsed">
            <ng-template pTemplate="header">
                <div
                    (click)="isDepartmentPanelCollapsed = !isDepartmentPanelCollapsed"
                    style="cursor: pointer"
                >
                    {{ 'IRONSIDE.product-list.department' | translate }}
                </div>
            </ng-template>
            <div
                class="wrap-input d-flex align-items-center justify-content-between gap-2 pb-2 mt-2"
            >
                <p-multiSelect
                    [filter]="true"
                    class="w-12"
                    [options]="getFilterTranslate(departments)"
                    optionLabel="translatedTitle"
                    optionValue="id"
                    placeholder="{{ 'IRONSIDE.product-list.choose-department' | translate }}"
                    formControlName="departments"
                    appendTo="body"
                >
                    <ng-template let-department pTemplate="item">
                        <div class="flex align-items-center gap-2">
                            <div class="truncate">
                                {{ department.title | translateDynamicLanguage }}
                            </div>
                        </div>
                    </ng-template>
                    <ng-template let-value pTemplate="selectedItems">
                        <div class="truncate">
                            <span
                                style="margin-right: 4px"
                                *ngFor="let option of departmentValueOption"
                            >
                                <span>{{ option?.title | translateDynamicLanguage }}</span>
                                <span *ngIf="departmentValueOption.length > 1">,</span>
                            </span>
                        </div>

                        <span
                            *ngIf="!departmentValueOption || departmentValueOption.length === 0"
                            >{{ 'IRONSIDE.product-list.choose-department' | translate }}</span
                        >
                    </ng-template>
                </p-multiSelect>
            </div>
        </p-panel>

        <p-panel [toggleable]="true" [(collapsed)]="isPackagingPanelCollapsed">
            <ng-template pTemplate="header">
                <div
                    (click)="isPackagingPanelCollapsed = !isPackagingPanelCollapsed"
                    style="cursor: pointer"
                >
                    {{ 'IRONSIDE.product-list.packaging' | translate }}
                </div>
            </ng-template>
            <div
                class="wrap-input d-flex align-items-center justify-content-between gap-2 pb-2 mt-2"
            >
                <p-multiSelect
                    [filter]="true"
                    class="w-12"
                    [options]="getFilterTranslate(packagings)"
                    optionLabel="translatedTitle"
                    optionValue="id"
                    placeholder="{{ 'IRONSIDE.product-list.choose-packaging' | translate }}"
                    formControlName="packaging"
                    appendTo="body"
                >
                    <ng-template let-packaging pTemplate="item">
                        <div class="truncate">
                            {{ packaging.title | translateDynamicLanguage }}
                        </div>
                    </ng-template>

                    <ng-template let-value pTemplate="selectedItems">
                        <div class="truncate">
                            <span
                                class="truncate"
                                style="margin-right: 4px"
                                *ngFor="let option of packagingValueOption"
                            >
                                <span>{{ option?.title | translateDynamicLanguage }}</span>
                                <span *ngIf="packagingValueOption.length > 1">,</span>
                            </span>
                        </div>

                        <span *ngIf="!packagingValueOption || packagingValueOption.length === 0">{{
                            'IRONSIDE.product-list.choose-packaging' | translate
                        }}</span>
                    </ng-template>
                </p-multiSelect>
            </div>
        </p-panel>

        <p-panel [toggleable]="true" [(collapsed)]="isPartnerPanelCollapsed">
            <ng-template pTemplate="header">
                <div
                    (click)="isPartnerPanelCollapsed = !isPartnerPanelCollapsed"
                    style="cursor: pointer"
                >
                    {{ 'IRONSIDE.product-list.selected-by' | translate }}
                </div>
            </ng-template>
            <div
                class="wrap-input d-flex align-items-center justify-content-between gap-2 pb-2 mt-2"
            >
                <p-multiSelect
                    [filter]="true"
                    class="w-12"
                    [options]="partners"
                    optionLabel="title"
                    optionValue="id"
                    placeholder="{{ 'IRONSIDE.product-list.choose-partners' | translate }}"
                    formControlName="partners"
                    appendTo="body"
                >
                </p-multiSelect>
            </div>
        </p-panel>
    </form>
</ng-template>

<ng-template #tagTemplate>
    <ng-container *ngIf="partnersValue && partnersValue.length > 0">
        <div class="group-tag d-flex align-items-center gap-2">
            <ng-container *ngFor="let code of partnersValue; let i = index">
                <div *ngIf="code" class="tag d-flex align-items-center">
                    {{ getPartnerByCode(code)?.title }}
                    <button
                        (click)="delStatus(code)"
                        class="d-flex justify-content-center align-items-center gap-1"
                    >
                        <i class="pi pi-times"></i>
                    </button>
                </div>
            </ng-container>
        </div>
    </ng-container>

    <ng-container *ngIf="supplierValue && supplierValue.length > 0">
        <div *ngIf="headerType !== 'supplier'" class="group-tag d-flex align-items-center gap-2">
            <ng-container *ngFor="let code of supplierValue; let i = index">
                <div *ngIf="code" class="tag d-flex align-items-center">
                    {{ getSupByCodeFilter(code)?.title }}
                    <button
                        (click)="delSupplier(code)"
                        class="d-flex justify-content-center align-items-center gap-1"
                    >
                        <i class="pi pi-times"></i>
                    </button>
                </div>
            </ng-container>
        </div>
    </ng-container>

    <ng-container *ngIf="brandValue && brandValue.length > 0">
        <div *ngIf="headerType !== 'marque'" class="group-tag d-flex align-items-center gap-2">
            <ng-container *ngFor="let code of brandValue; let i = index">
                <div *ngIf="code" class="tag d-flex align-items-center">
                    {{ getBrandByCodeFilter(code)?.title | translateDynamicLanguage }}
                    <button
                        (click)="delBrand(code)"
                        class="d-flex justify-content-center align-items-center gap-1"
                    >
                        <i class="pi pi-times"></i>
                    </button>
                </div>
            </ng-container>
        </div>
    </ng-container>

    <ng-container *ngIf="manufactoringCountryValue && manufactoringCountryValue.length > 0">
        <div class="group-tag d-flex align-items-center gap-2">
            <ng-container *ngFor="let code of manufactoringCountryValue; let i = index">
                <div *ngIf="code" class="tag d-flex align-items-center">
                    {{
                        getManufactoringCountryByCodeFilter(code)?.title | translateDynamicLanguage
                    }}
                    <button
                        (click)="delManufactoring(code)"
                        class="d-flex justify-content-center align-items-center gap-1"
                    >
                        <i class="pi pi-times"></i>
                    </button>
                </div>
            </ng-container>
        </div>
    </ng-container>

    <ng-container *ngIf="displayCategories.length > 0">
        <div class="group-tag d-flex align-items-center gap-2" *ngIf="categoryFilter === true">
            <ng-container *ngFor="let category of displayCategories">
                <div class="tag d-flex align-items-center">
                    {{ category.nameCategory | translateDynamicLanguage }}

                    <button
                        (click)="delCategory(category.id)"
                        class="d-flex justify-content-center align-items-center gap-1"
                    >
                        <i class="pi pi-times"></i>
                    </button>
                </div>
            </ng-container>
        </div>
    </ng-container>

    <ng-container *ngIf="isWithdrawnFromSaleValue">
        <div class="group-tag d-flex align-items-center gap-2">
            <ng-container *ngIf="isWithdrawnFromSaleValue">
                <div class="tag d-flex align-items-center">
                    <span>{{ 'IRONSIDE.product-list.off-market-product' | translate }}</span>
                    <button
                        (click)="delWithdrawnFromSaleValue()"
                        class="d-flex justify-content-center align-items-center gap-1"
                    >
                        <i class="pi pi-times"></i>
                    </button>
                </div>
            </ng-container>
        </div>
    </ng-container>

    <ng-container *ngIf="packagingValue && packagingValue.length > 0">
        <div class="group-tag d-flex align-items-center gap-2">
            <ng-container *ngFor="let code of packagingValue; let i = index">
                <div *ngIf="code" class="tag d-flex align-items-center">
                    {{ getPackagingByCodeFilter(code)?.title | translateDynamicLanguage }}
                    <button
                        (click)="delPackaging(code)"
                        class="d-flex justify-content-center align-items-center gap-1"
                    >
                        <i class="pi pi-times"></i>
                    </button>
                </div>
            </ng-container>
        </div>
    </ng-container>
    <ng-container *ngIf="departmentValue && departmentValue.length > 0">
        <div class="group-tag d-flex align-items-center gap-2">
            <ng-container *ngFor="let department of departmentValue; let i = index">
                <div *ngIf="department" class="tag d-flex align-items-center">
                    {{ getDepartmentByCodeFilter(department)?.title | translateDynamicLanguage }}
                    <button
                        (click)="delDepartment(department)"
                        class="d-flex justify-content-center align-items-center gap-1"
                    >
                        <i class="pi pi-times"></i>
                    </button>
                </div>
            </ng-container>
        </div>
    </ng-container>
    <ng-container *ngIf="isNewProductValue">
        <div class="group-tag d-flex align-items-center gap-2">
            <ng-container>
                <div class="tag d-flex align-items-center">
                    <span>{{ 'IRONSIDE.product-list.new-product' | translate }}</span>
                    <button
                        (click)="delNewProductValue()"
                        class="d-flex justify-content-center align-items-center gap-1"
                    >
                        <i class="pi pi-times"></i>
                    </button>
                </div>
            </ng-container>
        </div>
    </ng-container>
</ng-template>

<ng-template #actionTemplate>
    <ng-container *ngIf="!visibleDialog">
        <button (click)="visibleDialog = true" class="btn-common btn-modifier">
            {{ 'Catalogue.modify' | translate | uppercase }}
        </button>
        <button (click)="clearFilter()" class="btn-common btn-reset-filter">
            {{ 'IRONSIDE.product-list.reset-filters' | translate }}
        </button>
    </ng-container>
</ng-template>
<p-toast></p-toast>
